module.exports = __webpack_public_path__ + "img/030-031.61095ae7.jpg";